import { InjectionToken } from "@angular/core";

interface Conf {
  httpTimeout?: number;
  generalMessageTimeout?: number;
}

export const AppConfig: Conf = {
  httpTimeout: 30000,
  generalMessageTimeout: 5000,
};

export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: () => globalThis as any
});
